module.exports = __webpack_public_path__ + "img/premiumStarPurple.36fcb2d.svg";